import accounts from "accounts/Accounts.js";
import ethereum from 'decentralized/ethereum.js';
import {getProjects} from "components/sequences2/getProjects.js"
import {lstorage} from 'utils/lstorage.js';

export const checkLocalProjects = async () => {
    if (window.isNFT) {
        return [];
    }
    let localProjects = lstorage.getItem("sequences");
    if (localProjects) {
        localProjects = JSON.parse(localProjects).filter(
            x => x.title && x.title !== "");
    } else {
        localProjects = [];
    }

    let localIds = new Set(localProjects.map(x => x.newSequence));
    let syncedIds = await getUnfoldedProjects(localIds);

    let unsyncedLocalProjects = [];
    for (let project of localProjects) {
        if (!syncedIds.has(project.hash)) {
            unsyncedLocalProjects.push(project);
        }
    }
    lstorage.setItem("sequences", JSON.stringify(unsyncedLocalProjects));
    // check if theyve been successfully synced
};

const getUnfoldedProjects = async (ids) => {
    let user = await accounts.getAccount();
    let results = await ethereum.tokenizedSequences.getSequences(user, undefined, undefined);
    return new Set(results.map(x => x.newSequence));
};
